import React from 'react';
import { graphql } from 'gatsby';
import { Image } from '../../../Image/Image';

export const PortraitImage = ({ data, ...rest }) => (
  <Image src={data?.image?.image?.localFile} />
);

export const PortraitImageQuery = graphql`
  fragment PortraitImage on UMBRACO_PortraitImageComponentType {
    image {
      image {
        ...StandardPortraitImage
      }
    }
  }
`;
